<template>
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-v-2afdf54c-s=""
    style="width: 8px; height: 8px"
  >
    <path
      d="M11.1834 2.76939L5.33873 9.19674C4.90502 9.67537 4.20283 9.67537 3.76913 9.19674L0.774498 5.86911C0.340792 5.39047 0.340792 4.61554 0.774498 4.13691C1.2082 3.65828 1.91039 3.65828 2.3441 4.13691L4.55393 6.59845L9.61382 1.0372C10.0475 0.558565 10.7497 0.558565 11.1834 1.0372C11.6171 1.51583 11.6171 2.29076 11.1834 2.76939Z"
      fill="currentColor"
    ></path>
  </svg>
</template>
